<template>
  <div
    class="manage-content page-card-wrapper page-card-wrapper-adapt-actual-width"
  >
    <div class="page-card-title">
      <span class="page-card-title-text">{{ $t('text.Manufacturers') }}</span>
    </div>
    <div class="page-card-content">
      <div class="mt-20 page-content">
        <div class="section-title mb-20">
          <el-button
            type="success"
            plain
            class="common-btn mini-btn"
            @click="add()"
            v-if="p('Manufacturers.Add')"
            >{{ $t('text.add_manufacturer').toUpperCase() }}</el-button
          >
          <span class="right-float">
            <svg-icon
              iconClass="filter"
              className="content-element-color-more-lighter"
            ></svg-icon>
            <el-input
              v-model="filter"
              size="mini"
              class="search-input filter-input"
              :placeholder="$t('text.filter_by_manufacturer_code_or_name')"
            ></el-input>
          </span>
        </div>
        <el-table border :data="data" v-loading="loading">
          <el-table-column :label="$t('text.name')" prop="name">
          </el-table-column>
          <el-table-column :label="$t('text.address')" prop="address">
          </el-table-column>
          <el-table-column :label="$t('text.phone')" prop="contact">
          </el-table-column>
          <el-table-column :label="$t('text.enabled')">
            <template slot-scope="scope">
              <el-switch
                disabled
                class="is-enabled"
                v-model="scope.row.isEnabled"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('text.action')"
            v-if="p('Manufacturers.Delete')"
          >
            <template slot-scope="scope">
              <div
                class="red-font underline pointer inline-block"
                @click="deleteManufacturer(scope.row)"
              >
                {{ $t('text.delete') | firstLetterCapitalize }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <AddManufacturer
      ref="addManufacturer"
      @updateManufactures="getManufactures"
    />
  </div>
</template>

<script>
import AddManufacturer from '@/components/manage/patients/editPatient/AddManufacturer.vue'
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      filter: '',
      data: [],
      loading: false,
      timer: '',
      user: JSON.parse(localStorage.getItem('user'))
    }
  },
  components: {
    AddManufacturer
  },
  mounted() {
    this.getManufactures()
  },
  watch: {
    filter() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.getManufactures, 500)
    }
  },
  methods: {
    getManufactures() {
      this.loading = true
      ApiService.GetOrganisationManufacturer(
        this.$store.getters[`user/selecteOrganisationId`]
      )
        .then(response => {
          this.loading = false
          let params = response.data.data.map(item => {
            return {
              manufacturerId: item.ManufacturerId,
              code: item.Code
            }
          })
          if (params && params.length) {
            this.getManufacturersByIds(params)
          } else {
            this.data = []
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    getManufacturersByIds(params) {
      this.loading = true
      ApiService.GetManufacturersByIds(params)
        .then(response => {
          this.loading = false
          this.data = response.data.data.filter(item => {
            return (
              item.manufacturerCode
                .toLowerCase()
                .indexOf(this.filter.toLowerCase()) > -1 ||
              item.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1
            )
          })
        })
        .catch(() => {
          this.loading = false
        })
    },
    add() {
      this.$refs.addManufacturer.openDialog()
    },
    deleteManufacturer(item) {
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      this.$confirm(
        `<div class='warning-content'>${this.$t(
          'text.delete_manufacturer_warning'
        )}</div><img class='warning-icon' src=${warningIconUrl}>`,
        this.$t('text.you_able_to_delete_data') + ' ' + item.name,
        {
          confirmButtonText: this.$t('text.delete').toUpperCase(),
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'confirm-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: true,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          this.handleDelete(item)
        })
        .catch(() => {})
    },
    handleDelete(item) {
      this.loading = true
      ApiService.DeleteOrganisationManufacturer(
        item.id,
        this.$store.getters[`user/selecteOrganisationId`]
      )
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.getManufactures()
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>

<style lang="scss" scoped>
.is-enabled::v-deep {
  &.el-switch.is-disabled {
    opacity: 1;
  }
}
</style>
